/**
 * Conclusion result screen.
 */
import React from "react";
import { useTranslation } from 'react-i18next';

/**
 * Thanks the learner after the conclusion survey.
 */
const ConclusionResult = () => {

  const { t } = useTranslation('common');

  return <>
    <div className="w-full mb-4">
      <div className="shadow mt-5 p-4 text-center">
        <div className="fsp-18 mt-5">
          <span className="font-bold ">{t('Thank you for your comeback.')}</span>
        </div>
        <div className="mt-5 text-base text-muted">
          {t('The pedagogical team.')}
        </div>
      </div>
    </div>
  </>
}

export default ConclusionResult;